<form [formGroup]="formGroupInput()">
  <div class="card">
    <div class="card-header">
      {{ "registrationWizard.legalPersonForm.dataOfLegalPerson" | translate }}
    </div>
    <div class="card-body">
      @if (authFromPartner) {
        <app-upload-files
          [title]="'registrationWizard.documentUploadForm.authFromPartner'"
          [formControls]="authFromPartner"
        ></app-upload-files>
      }
      @if (authFromRepresentative) {
        <app-upload-files
          [title]="
            'registrationWizard.documentUploadForm.authFromRepresentative'
          "
          [formControls]="authFromRepresentative"
          [canAdd]="false"
        ></app-upload-files>
      }
      @if (signatureOfAuthFromRepresentative) {
        <app-upload-files
          [title]="
            'registrationWizard.documentUploadForm.signatureOfAuthFromRepresentative'
          "
          [formControls]="signatureOfAuthFromRepresentative"
          [canAdd]="false"
        ></app-upload-files>
      }
    </div>
  </div>
</form>
